//always add 'admin' in key to distinguish it from client paths
const adminPaths = {
	admin: '/admin',
	admin_dashboard: '/admin/dashboard',
	admin_dashboard_all: '/admin/dashboard/all',
	admin_dashboard_map: '/admin/dashboard/map',
	admin_dashboard_manufacturer: '/admin/dashboard/manufacturer',
	admin_dashboard_sales: '/admin/dashboard/sales',
	admin_dashboard_supply: '/admin/dashboard/supply',
	admin_dashboard_reports: '/admin/dashboard/report',
	admin_dashboard_overall: '/admin/dashboard/overall',
	admin_dashboard_target: '/admin/dashboard/target',
	admin_dashboard_pending_order: '/admin/dashboard/pending-order',
	admin_dashboard_leaderboard: '/admin/dashboard/leaderboard',
	admin_profile: '/admin/profile',
	admin_organisations: '/admin/organisations',
	admin_admins: '/admin/admins',
	admin_view_admins: '/admin/admins/view-admins',
	admin_unregistered: '/admin/admins/unregistered',
	admin_organisations_view: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId
	},
	admin_organisations_details: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/details'
	},
	admin_organisations_mbook: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/mbook'
	},
	admin_organisations_underwriting: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/underwriting'
	},
	admin_organisations_underwriting_inspection: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/inspection-reports'
	},
	admin_organisations_underwriting_financial: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/financial-reports'
	},
	admin_organisations_underwriting_cran: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/cran'
	},
	admin_organisations_underwriting_cran_by_id: (orgId = '', cranId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		if (cranId === '') {
			cranId = ':cranId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/cran/report/' + cranId
	},
	admin_organisations_underwriting_inspection_report: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/inspection-reports/report'
	},
	admin_organisations_cran_report: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/cran/report'
	},
	admin_organisations_financial_report: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/financial-reports/report'
	},
	admin_organisations_financial_report_details: (orgId = '', probeId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		if (probeId === '') {
			probeId = ':probeId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/financial-reports/report/' + probeId + '/company-details'
	},
	admin_organisations_financial_report_management: (orgId = '', probeId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		if (probeId === '') {
			probeId = ':probeId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/financial-reports/report/' + probeId + '/management'
	},
	admin_organisations_financial_report_financials: (orgId = '', probeId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		if (probeId === '') {
			probeId = ':probeId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/financial-reports/report/' + probeId + '/financials'
	},
	admin_organisations_financial_report_consolidated: (orgId = '', probeId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		if (probeId === '') {
			probeId = ':probeId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/financial-reports/report/' + probeId + '/consolidated'
	},
	admin_organisations_financial_report_charges: (orgId = '', probeId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		if (probeId === '') {
			probeId = ':probeId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/financial-reports/report/' + probeId + '/charges'
	},
	admin_organisations_financial_report_compliance: (orgId = '', probeId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		if (probeId === '') {
			probeId = ':probeId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/financial-reports/report/' + probeId + '/compliance'
	},
	admin_organisations_financial_report_shareholding: (orgId = '', probeId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		if (probeId === '') {
			probeId = ':probeId'
		}
		return '/admin/organisations/' + orgId + '/underwriting/financial-reports/report/' + probeId + '/shareholding'
	},
	admin_organisations_mbook_dashboard: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/mbook/dashboard'
	},
	admin_organisations_mbook_enquiry: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/mbook/enquiry'
	},
	admin_organisations_mbook_order: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/mbook/order'
	},
	admin_organisations_mbook_ledger: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/mbook/ledger'
	},
	admin_organisations_mbook_collections: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/mbook/collections'
	},
	admin_organisations_mbook_credit_limit: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/mbook/credit-limit'
	},
	admin_organisations_details_org: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/details/org-details'
	},
	admin_organisations_details_gst: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/details/gst'
	},
	admin_organisations_details_address: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/details/saved-address'
	},
	admin_organisations_details_users: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/details/users'
	},
	admin_organisations_details_financials: (orgId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		return '/admin/organisations/' + orgId + '/details/basic-financials'
	},
	admin_organisations_edit_user: (orgId = '', userId = '') => {
		if (orgId === '') {
			orgId = ':orgId'
		}
		if (userId === '') {
			userId = ':userId'
		}
		return '/admin/organisations/' + orgId + '/user/' + userId
	},
	admin_edit_user: (userId = '') => {
		if (userId === '') {
			userId = ':userId'
		}
		return '/admin/admins/edit-user/' + userId
	},

	admin_catalog: '/admin/catalog',
	admin_catalog_categories: '/admin/catalog/categories',
	admin_catalog_create_category: '/admin/catalog/create-category',
	admin_catalog_products: '/admin/catalog/products',
	admin_catalog_create_product: '/admin/catalog/create-product',
	admin_catalog_website_categories: '/admin/catalog/website/categories',

	admin_catalog_brands: '/admin/catalog/brands',
	admin_catalog_create_brand: '/admin/catalog/create-brand',
	admin_catalog_commodity: '/admin/catalog/commodity',

	admin_catalog_edit_category: (categoryId = '', source = '') => {
		if (categoryId === '') {
			categoryId = ':categoryId'
		}
		if (source === '') {
			source = ':source'
		}
		return '/admin/catalog/edit-category/' + categoryId + '/' + source
	},

	admin_catalog_edit_product: (productId = '') => {
		if (productId === '') {
			productId = ':productId'
		}
		return '/admin/catalog/edit-product/' + productId
	},

	admin_enquiry: '/admin/enquiry',
	admin_create_enquiry: '/admin/enquiry/create-enquiry',
	admin_punch_order: '/admin/enquiry/punch-order',
	admin_punch_order_create: '/admin/enquiry/punch-order/create',
	admin_punch_order_view: (punchOrderId = '') => {
		if (punchOrderId === '') {
			punchOrderId = ':punchOrderId'
		}
		return '/admin/enquiry/punch-order/view/' + punchOrderId
	},

	admin_manage_enquiry: '/admin/enquiry/manage-enquiry',
	admin_manage_enquiry_assign: '/admin/enquiry/manage-enquiry/assign',
	admin_manage_enquiry_verify: '/admin/enquiry/manage-enquiry/verify',
	admin_manage_enquiry_all: '/admin/enquiry/manage-enquiry/all',
	admin_manage_enquiry_my: '/admin/enquiry/manage-enquiry/my',
	admin_manage_enquiry_active: '/admin/enquiry/manage-enquiry/active',
	admin_manage_enquiry_all_create_order: '/admin/enquiry/manage-enquiry/create-orders',
	admin_manage_enquiry_submit_quote: '/admin/enquiry/manage-enquiry/submit-quote',
	admin_manage_enquiry_active_quote: '/admin/enquiry/manage-enquiry/active-quote',
	admin_manage_enquiry_all_quote: '/admin/enquiry/manage-enquiry/all-quote',
	admin_manage_enquiry_view: (enquiryId = '') => {
		if (enquiryId === '') {
			enquiryId = ':enquiryId'
		}
		return '/admin/enquiry/manage-enquiry/view/' + enquiryId
	},
	admin_manage_enquiry_edit: (enquiryId = '') => {
		if (enquiryId === '') {
			enquiryId = ':enquiryId'
		}
		return '/admin/enquiry/manage-enquiry/edit/' + enquiryId
	},
	admin_manage_enquiry_manage: (enquiryId = '') => {
		if (enquiryId === '') {
			enquiryId = ':enquiryId'
		}
		return '/admin/enquiry/manage-enquiry/manage/' + enquiryId
	},
	admin_manage_enquiry_manage_details: (enquiryId = '') => {
		if (enquiryId === '') {
			enquiryId = ':enquiryId'
		}
		return '/admin/enquiry/manage-enquiry/manage/' + enquiryId + '/details'
	},
	admin_manage_enquiry_manage_supplier_quotes: (enquiryId = '') => {
		if (enquiryId === '') {
			enquiryId = ':enquiryId'
		}
		return '/admin/enquiry/manage-enquiry/manage/' + enquiryId + '/supplier-quotes'
	},
	admin_manage_enquiry_manage_buyer_quotes: (enquiryId = '') => {
		if (enquiryId === '') {
			enquiryId = ':enquiryId'
		}
		return '/admin/enquiry/manage-enquiry/manage/' + enquiryId + '/buyer-quotes'
	},
	admin_manage_enquiry_manage_logistics_quote: (enquiryId = '') => {
		if (enquiryId === '') {
			enquiryId = ':enquiryId'
		}
		return '/admin/enquiry/manage-enquiry/manage/' + enquiryId + '/logistics-quote'
	},
	admin_manage_enquiry_manage_preview_po: (enquiryId = '') => {
		if (enquiryId === '') {
			enquiryId = ':enquiryId'
		}
		return '/admin/enquiry/manage-enquiry/manage/' + enquiryId + '/preview-po'
	},
	admin_manage_enquiry_orders: '/admin/order/manage-enquiry-orders',
	admin_manage_enquiry_orders_active_trip: '/admin/order/manage-enquiry-orders/active-trip',
	admin_manage_enquiry_order_status: (status = '') => {
		if (status === '') {
			status = ':orderStatus'
		}
		return '/admin/order/manage-enquiry-orders/' + status
	},
	admin_manage_enquiry_orders_active_invoice: '/admin/order/manage-enquiry-orders/active-invoice',
	admin_manage_enquiry_orders_order_book: '/admin/order/manage-enquiry-orders/order-book',
	admin_manage_enquiry_orders_pending_dispatch: '/admin/order/manage-enquiry-orders/pending-dispatch',

	admin_spo: '/admin/spo',
	// Create/Edit SPO (redesigned flow — the old stepper flow was removed).
	admin_create_spo: '/admin/spo/create-spo',
	admin_edit_spo: (spoId = '') => {
		if (spoId === '') {
			spoId = ':spoId'
		}
		return '/admin/spo/edit-spo/' + spoId
	},

	admin_manage_spo: '/admin/spo/manage-spo',
	admin_manage_spo_status: (status = '') => {
		if (status === '') {
			status = ':orderStatus'
		}
		return '/admin/spo/manage-spo/' + status
	},

	admin_manage_enquiry_order_edit: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId
	},
	admin_manage_enquiry_order_edit_details: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/sales-order'
	},
	admin_manage_enquiry_order_edit_suppliers: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/purchase-orders'
	},
	admin_manage_enquiry_order_edit_preview_po: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/preview-po'
	},
	admin_manage_enquiry_order_edit_dispatch_plans: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/dispatch-plans'
	},
	admin_manage_enquiry_order_edit_dispatch_plans_create: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/dispatch-plans/create'
	},
	admin_manage_enquiry_order_edit_dispatch_plans_edit: (orderId = '', dispatchPlanId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		if (dispatchPlanId === '') {
			dispatchPlanId = ':dispatchPlanId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/dispatch-plans/edit/' + dispatchPlanId
	},
	admin_manage_enquiry_order_edit_fulfillment: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/shipment'
	},
	admin_manage_enquiry_order_edit_fulfillment_create: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/shipment/create'
	},
	admin_manage_enquiry_order_edit_fulfillment_edit: (orderId = '', shipmentRequestId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		if (shipmentRequestId === '') {
			shipmentRequestId = ':shipmentRequestId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/shipment/edit/' + shipmentRequestId
	},
	// Every fulfillment plan of the order (its own section of the Shipment tab).
	admin_manage_enquiry_order_edit_fulfillment_plans: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/fulfillment-plans'
	},
	admin_manage_enquiry_order_edit_fulfillment_plan_create: (orderId = '', shipmentRequestId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		if (shipmentRequestId === '') {
			shipmentRequestId = ':shipmentRequestId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/shipment/edit/' + shipmentRequestId + '/fulfillment/create'
	},
	admin_manage_enquiry_order_edit_fulfillment_plan_edit: (orderId = '', shipmentRequestId = '', fulfillmentPlanId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		if (shipmentRequestId === '') {
			shipmentRequestId = ':shipmentRequestId'
		}
		if (fulfillmentPlanId === '') {
			fulfillmentPlanId = ':fulfillmentPlanId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/shipment/edit/' + shipmentRequestId + '/fulfillment/edit/' + fulfillmentPlanId
	},
	admin_manage_enquiry_order_edit_logistics_quote: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/order/manage-enquiry-orders/edit/' + orderId + '/logistics-quotes'
	},

	admin_payment_summary: '/admin/payment-summary',
	admin_ledger: '/admin/payment-summary/ledger',
	admin_sale_invoices: '/admin/payment-summary/sale-invoices',
	admin_purchase_invoices: '/admin/payment-summary/purchase-invoices',
	admin_past_record: '/admin/payment-summary/past-records',
	admin_due_payments: '/admin/payment-summary/due-payments',
	admin_advance_to_supplier: '/admin/payment-summary/advance-to-supplier',
	admin_collections: '/admin/payment-summary/collections',
	admin_payment: '/admin/payment-summary/payment',

	admin_list_inventory: '/admin/inventory',
	admin_add_inventory: '/admin/inventory/add',

	admin_bid_auction: '/admin/auction',
	admin_create_auction: '/admin/auction/create-auction',

	admin_manage_auction: '/admin/auction/manage-auction',
	admin_manage_auction_assign: '/admin/auction/manage-auction/assign',
	admin_manage_auction_verify: '/admin/auction/manage-auction/verify',
	admin_manage_auction_all: '/admin/auction/manage-auction/all',
	admin_manage_auction_my: '/admin/auction/manage-auction/my',
	admin_manage_auction_active: '/admin/auction/manage-auction/active',
	admin_manage_auction_view: (auctionId = '') => {
		if (auctionId === '') {
			auctionId = ':auctionId'
		}
		return '/admin/auction/manage-auction/view/' + auctionId
	},
	admin_manage_auction_edit: (auctionId = '') => {
		if (auctionId === '') {
			auctionId = ':auctionId'
		}
		return '/admin/auction/manage-auction/edit/' + auctionId
	},
	admin_manage_auction_manage: (auctionId = '') => {
		if (auctionId === '') {
			auctionId = ':auctionId'
		}
		return '/admin/auction/manage-auction/manage/' + auctionId
	},

	admin_manage_auction_orders: '/admin/auction-order/manage-auction-orders',
	admin_manage_auction_order_status: (status = '') => {
		if (status === '') {
			status = ':orderStatus'
		}
		return '/admin/auction-order/manage-auction-orders/' + status
	},
	admin_manage_auction_order_edit: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/auction-order/manage-auction-orders/edit/' + orderId
	},

	admin_logistics: '/admin/logistics',
	admin_create_logistics: '/admin/logistics/create-enquiry',
	admin_logistics_all: '/admin/logistics/all',
	admin_logistics_order: '/admin/logistics/order',
	admin_manage_logistics: '/admin/logistics/manage-logistics',
	admin_logistics_price: '/admin/logistics/price',
	admin_manage_logistics_quotes: '/admin/logistics/manage-logistics/quotes',

	admin_logistics_quote_all: '/admin/logistics/all',
	admin_logistics_quote_active: '/admin/logistics/active',
	admin_logistics_quote_order_placed: '/admin/logistics/order-placed',
	admin_create_logistics_quote: '/admin/logistics/create',

	admin_manage_logistics_view: (logisticsId = '') => {
		if (logisticsId === '') {
			logisticsId = ':logisticsId'
		}
		return '/admin/logistics/manage-logistics/view/' + logisticsId
	},
	admin_manage_logistics_edit: (logisticsId = '') => {
		if (logisticsId === '') {
			logisticsId = ':logisticsId'
		}
		return '/admin/logistics/manage-logistics/edit/' + logisticsId
	},
	admin_manage_logistics_order_details: (logisticsOrderId = '') => {
		if (logisticsOrderId === '') {
			logisticsOrderId = ':logisticsOrderId'
		}
		return '/admin/logistics/manage-logistics/order/details/' + logisticsOrderId
	},
	admin_cloud_factory: '/admin/cloud-factory',
	admin_cloud_factories: '/admin/cloud-factory/factories',
	admin_cloud_machines: '/admin/cloud-factory/machines',
	admin_cloud_orders: '/admin/cloud-factory/orders',
	admin_add_factory: '/admin/cloud-factory/factories/add',
	admin_add_machine_template: '/admin/cloud-factory/machines/add',
	admin_cloud_edit_machine: (machineId = '') => {
		if (machineId === '') {
			machineId = ':machineId'
		}
		return '/admin/cloud-factory/machines/edit/' + machineId
	},
	admin_cloud_edit_factory: (factoryId = '') => {
		if (factoryId === '') {
			factoryId = ':factoryId'
		}
		return '/admin/cloud-factory/factories/edit/' + factoryId
	},
	admin_cloud_factory_create_order: '/admin/cloud-factory/order/create',
	admin_cloud_factory_manage_order: (orderId = '') => {
		if (orderId === '') {
			orderId = ':orderId'
		}
		return '/admin/cloud-factory/order/manage/' + orderId
	},

	admin_tools: '/admin/tools',
	admin_tools_all: '/admin/tools/all',
	admin_tools_endorsement: '/admin/tools/endorsement',
	admin_tools_invoice_endorsement: '/admin/tools/invoice-endorsement',
	admin_tools_logistics_calculator: '/admin/tools/logistics-calculator',
	admin_tools_distance_calculator: '/admin/tools/distance-calculator',
	admin_tools_vernacularize: '/admin/tools/vernacularize',
	admin_tools_ifc: '/admin/tools/ifc',
	admin_tools_banner: '/admin/tools/banner',
	admin_weight_calculator: '/admin/tools/weight-calculator',
	admin_tools_data_correction: '/admin/tools/data-correction',
	admin_tools_fetch_from_probe: '/admin/tools/fetch-from-probe',
	admin_tools_po_invoice_mapping: '/admin/tools/po-invoice-mapping',
	admin_tools_reconciliation_process: '/admin/tools/reconciliation-process',
	admin_tools_upload_dashboard_report: '/admin/tools/upload-dashboard-report',

	admin_content: '/admin/content',
	admin_content_all: '/admin/content/all',
	admin_content_banner: '/admin/content/banner',
	admin_content_blog: '/admin/content/blog',
	admin_content_blog_create: '/admin/content/blog/create',
	admin_content_blog_edit: (contentId = '') => {
		if (contentId === '') {
			contentId = ':contentId'
		}
		return '/admin/content/blog/edit/' + contentId
	},
	admin_content_news: '/admin/content/news',
	// admin_content_news_create: '/admin/content/news/create',
	// admin_content_news_edit: (newsId = '') => {
	// 	if (newsId === '') {
	// 		newsId = ':newsId'
	// 	}
	// 	return '/admin/content/news/edit/' + newsId
	// },
	admin_content_glossary: '/admin/content/glossary',
	admin_content_glossary_create: '/admin/content/glossary/create',
	admin_content_glossary_edit: (glossarySlug = '') => {
		if (glossarySlug === '') {
			glossarySlug = ':glossarySlug'
		}
		return '/admin/content/glossary/edit/' + glossarySlug
	},

	admin_reports: '/admin/reports',
	admin_reports_all: '/admin/reports/all',
	admin_view_report: (reportType = '') => {
		if (reportType === '') {
			reportType = ':reportType'
		}
		return '/admin/reports/all/' + reportType
	},

	admin_approval_metrics: '/admin/approval-metrics',
	admin_approval_metrics_all_actions: '/admin/approval-metrics/all-actions',
	admin_approval_metrics_approved: '/admin/approval-metrics/approved',
	admin_approval_metrics_declined: '/admin/approval-metrics/declined',
	admin_approval_metrics_pending: '/admin/approval-metrics/pending',
	admin_approval_metrics_history: '/admin/approval-metrics/history',

	admin_commodity_prices: '/admin/commodity-prices',
	admin_bills: '/admin/bills',

	admin_underwriting: '/admin/underwriting',
	admin_underwriting_inspection_reports: '/admin/underwriting/inspection-reports',
	admin_underwriting_financial_reports: '/admin/underwriting/financial-reports',
	admin_underwriting_cran_reports: '/admin/underwriting/cran',
	admin_underwriting_all: '/admin/underwriting/all',
	admin_underwriting_cran: '/admin/underwriting/all/cran',
	admin_underwriting_view: '/admin/underwriting/view',
	sale_admin_collections: '/admin/collections',

	admin_dispatch_plan: '/admin/dispatch-plan',
	admin_dispatch_plan_reports: '/admin/dispatch-plan/reports',
	admin_dispatch_plan_all: '/admin/dispatch-plan/all',
	admin_dispatch_plan_active: '/admin/dispatch-plan/active',
	admin_dispatch_plan_shipment: '/admin/dispatch-plan/shipment',
	admin_dispatch_plan_fulfillment: '/admin/dispatch-plan/fulfillment',
	admin_dispatch_plan_create: '/admin/dispatch-plan/create',

	tenderbook: '/admin/tenderbook',

	tenderbook_user_list: '/admin/tenderbook/user-list',
	tenderbook_leads_list: '/admin/tenderbook/leads',
	tenderbook_tender_master: '/admin/tenderbook/tender-master',
	tenderbook_tender_bidder_search: '/admin/tenderbook/bidder-search',

	// Tenderbook user detail — a top-level admin route (not nested under the tenderbook
	// layout) so the list's search / export bar doesn't render over the detail tabs.
	tenderbook_user: (userId = '') => {
		if (userId === '') {
			userId = ':userId'
		}
		return '/admin/tenderbook/user/' + userId
	},
	tenderbook_user_basic_details: (userId = '') => {
		if (userId === '') {
			userId = ':userId'
		}
		return '/admin/tenderbook/user/' + userId + '/basic-details'
	},
	tenderbook_user_overview: (userId = '') => {
		if (userId === '') {
			userId = ':userId'
		}
		return '/admin/tenderbook/user/' + userId + '/overview'
	},
	tenderbook_user_subscription: (userId = '') => {
		if (userId === '') {
			userId = ':userId'
		}
		return '/admin/tenderbook/user/' + userId + '/subscription'
	},
	tenderbook_user_tender_activity: (userId = '') => {
		if (userId === '') {
			userId = ':userId'
		}
		return '/admin/tenderbook/user/' + userId + '/tender-activity'
	},
	tenderbook_user_searches: (userId = '') => {
		if (userId === '') {
			userId = ':userId'
		}
		return '/admin/tenderbook/user/' + userId + '/searches-and-follows'
	},

	admin_lead: '/admin/lead',
	admin_lead_all: '/admin/lead/all',
	admin_manage_lead: '/admin/lead/manage-lead',
	admin_lead_details: (leadId = '') => {
		if (leadId === '') {
			leadId = ':leadId'
		}
		return '/admin/lead/manage-lead/details/' + leadId
	},
	admin_lead_details_edit: (leadId = '') => {
		if (leadId === '') {
			leadId = ':leadId'
		}
		return '/admin/lead/manage-lead/details/edit/' + leadId
	},
	// admin_lead_inspection_lead: (leadId = '') => {
	// 	if (leadId === '') {
	// 		leadId = ':leadId'
	// 	}
	// 	return '/admin/lead/manage-lead/inspection-lead/' + leadId
	// },
	admin_lead_inspection_lead_list: (leadId = '') => {
		if (leadId === '') {
			leadId = ':leadId'
		}
		return '/admin/lead/manage-lead/inspection-lead-list/' + leadId
	},
	admin_lead_inspection_lead_add: (leadId = '') => {
		if (leadId === '') {
			leadId = ':leadId'
		}
		return '/admin/lead/manage-lead/inspection-lead/' + leadId
	},
	admin_lead_inspection_lead_new: (leadId = '') => {
		if (leadId === '') {
			leadId = ':leadId'
		}
		return '/admin/lead/manage-lead/inspection-lead/new/' + leadId
	},
	admin_lead_inspection_lead_edit: (leadId = '', inspectionReportId = '') => {
		if (leadId === '') {
			leadId = ':leadId'
		}
		const base = '/admin/lead/manage-lead/inspection-lead/edit/' + leadId
		return inspectionReportId ? `${base}?inspection_report_id=${inspectionReportId}` : base
	},
	admin_lead_Journey: (leadId = '') => {
		if (leadId === '') {
			leadId = ':leadId'
		}
		return '/admin/lead/manage-lead/journey/' + leadId
	},
	admin_lead_Meetings: (leadId = '') => {
		if (leadId === '') {
			leadId = ':leadId'
		}
		return '/admin/lead/manage-lead/meetings/' + leadId
	},
	admin_lead_notes: (leadId = '') => {
		if (leadId === '') {
			leadId = ':leadId'
		}
		return '/admin/lead/manage-lead/notes/' + leadId
	},
	admin_lead_task_reminder: (leadId = '') => {
		if (leadId === '') {
			leadId = ':leadId'
		}
		return '/admin/lead/manage-lead/task-reminder/' + leadId
	},
}

export default adminPaths
